import React, { Component } from 'react';
import i18n from 'i18n';
import Platform from 'platform';
import { FocusableParent } from 'components/navigation';
import { StyledBlock, StyledLogo, StyledText, StyledButton } from './StyledComponents';

const i18nScope = 'technicalStubPage';

export default class TechnicalStubPage extends Component {
  exitApp() {
    Platform.exit();
  }
  render() {
    return (
      <StyledBlock>
        <StyledLogo />
        <StyledText>{i18n.t(`${i18nScope}.description`)}</StyledText>
        <FocusableParent defaultSection>
          <StyledButton onEnter={this.exitApp}>{i18n.t(`${i18nScope}.exitAppButton`)}</StyledButton>
        </FocusableParent>
      </StyledBlock>
    );
  }
}
